// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Tablet */
  /* For Desktop */
}
:host-context(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body {
  width: 100%;
}
:host-context(.aulani) img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left {
  float: left;
}
:host-context(.aulani) .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after {
  content: none;
}
:host-context(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select {
  vertical-align: middle;
}
:host-context(.aulani) address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear {
  display: none;
}
:host-context(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .top-section {
  display: none;
  width: 95%;
  margin: 0 auto;
  color: #382613;
}
:host-context(.aulani) .top-section .breadcrumbs-section {
  width: 80%;
  padding-left: 5px;
  padding-bottom: 9px;
}
:host-context(.aulani) .top-section .breadcrumbs-section .breadcrumb-item {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}
:host-context(.aulani) .top-section .breadcrumbs-section .breadcrumb-item span.di.di-home {
  vertical-align: text-top;
  font-size: 14px;
}
:host-context(.aulani) .top-section .breadcrumbs-section .breadcrumb-item span.di.di-next {
  font-size: 10px;
  padding-right: 5px;
  vertical-align: middle;
}
:host-context(.aulani) .top-section .breadcrumbs-section .breadcrumb-item a,
:host-context(.aulani) .top-section .breadcrumbs-section .breadcrumb-item a:link {
  font-family: "InspireTWDCMedium";
  font-size: 12px;
  color: #382613;
}
:host-context(.aulani) .top-section .breadcrumbs-section .breadcrumb-item a:hover {
  color: #B14308;
  border-bottom: 1px solid #B14308;
}
:host-context(.aulani) .top-section .print {
  width: 20%;
  text-align: right;
  font-family: "InspireTWDCHeavy";
  font-size: 12px;
  margin-bottom: 9px;
  position: relative;
  padding-right: 20px;
}
:host-context(.aulani) .top-section .print a:link {
  color: #382613;
}
:host-context(.aulani) .top-section .print a:hover {
  color: #B14308;
}
:host-context(.aulani) .top-section .print .di-print {
  font-family: PeptasiaInteractive;
  font-size: 14px;
  position: absolute;
  display: block;
  right: 30px;
  color: #382613;
}
:host-context(.aulani) .top-section .print .di-print:hover {
  color: #B14308;
}
:host-context(.aulani) .top-section .print .di-print-text:hover {
  color: #B14308;
}
:host-context(.aulani) .top-section .print .di-print-text {
  color: #382613;
}
:host-context(.aulani) .tnc-page {
  width: 95%;
  font-family: "InspireTWDCRoman";
  margin: 0 auto;
  background: #FFF;
  padding: 6px 20px 20px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
}
:host-context(.aulani) .tnc-page h1 {
  font-size: 20px;
  line-height: 33px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  margin-bottom: 14px;
  letter-spacing: -0.18px;
}
:host-context(.aulani) .tnc-page .page-content p {
  margin-bottom: 20px;
}
:host-context(.aulani) .page-layout {
  background: #FFF;
  min-height: 100vh;
  padding: 40px 0 20px;
}
@media (min-width: 767px) {
  :host-context(.aulani) .top-section {
    display: flex;
  }
  :host-context(.aulani) .tnc-page {
    padding: 42px 46px 42px 50px;
  }
  :host-context(.aulani) .tnc-page h1 {
    font-size: 28px;
    line-height: 33px;
    font-weight: 400;
    letter-spacing: 0;
    margin-bottom: 19px;
  }
}
@media (min-width: 1024px) {
  :host-context(.aulani) .tnc-page,
  :host-context(.aulani) .top-section {
    width: 940px;
  }
  :host-context(.aulani) ::ng-deep ul {
    list-style: disc;
    margin-bottom: 20px;
    padding: 0 0 0 15px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) ::ng-deep p {
    margin-bottom: 20px;
  }
}
@media (max-width: 1024px) {
  :host-context(.aulani) ::ng-deep ul {
    list-style: disc;
    padding: 0 19px 0 40px;
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0;
  }
}

:host-context(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Tablet */
  /* For Desktop */
}
:host-context(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body {
  width: 100%;
}
:host-context(.wdw) img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left {
  float: left;
}
:host-context(.wdw) .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after {
  content: none;
}
:host-context(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select {
  vertical-align: middle;
}
:host-context(.wdw) address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear {
  display: none;
}
:host-context(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .pepde {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAKuCAYAAABgwHabAAADZ0lEQVRIS83QZ08UURQG4NzfgaggKggSu9iCsaJYI2qkGLE3BIOKJbFEFBGjRkOv0kHq0kGaAtIEgkgHe++/YHzvYcc7M9ldAfnAlyenz91lxYO/JUYUDfxSUtj/U2J5/T+U6PhILm/o+kBOH7pEFiezF7WMHkSC9J7vEiPSur8h6sZIaifSlC4VybxGJL3AXMJf4ju+SoyI60BDQ/RzNIio9i8cjBAR7agJwto+SyysDTVlhDSkFWvBLegGtyC93ypzrwUNwd1nSO80Y05wu+mTxIhbzSCo6aNMI+aCODcb0AhsBDca0A2sV0E1IqD+g8Su12OOCKDoKRrENY5/HUb869DQQym4Wovulbp/crkWwxou8QPExRpTXKh5LzHi/JN3SpQ1HDj3GCPE2WrM+Q2BBnGmCg2/SkCRIU5Xo3GqCmuEb+VbZXqSp4RvBeYIURORT8UbiflU4ABxogIb3pWIvMt5VC7XvB4hVVCGNS/O8SEwp0euHSvFxuFSpEfK5IjSoyUyh0pe60coIg4a40DxK4npwYH9RRjWsK9YVdtbhA3Cs/ClMqLUswDDGvbkY3h3ARARpR6FnHyseeRjzZ3vuhcgdcsfVIM5N36FcM2jETmilNilw5qrDo2dOqSCHblomGY733XJHZDYtmxEhEsOrmzNQWSULdnYMMTmLKwZYhNvGGJjJk4RGzL69ThnItKDNedMzkMakdP1GUg1OPHaunSZtXzDKQ2nKBKsSUdtGKxO65PYqnROGg6sTMUaRSKlmoYVKdigGkXE8lQVjim9EjMM1hxTjLCMn9KShFNUW5qMyChLknokpiURa4uTVCxKxBWjLORfE12HBBx1SMABwQJ1Oj8eG4aY9wC7RrvUoBGjzOHduXyOoqE0To5mx3VLbJTMiu2SmCHseUMJvmYfS2galMrdmTF4yxhiG4PzhF20AF+ziwa2JpkRhbeMEptIfM001lEYUYIHWUcRoiFqcmQTiWh6JJ6mpJOnhKahSqfyLmF6jrpiWERWEXgaMU2NaIxoRLM2JRyXCUt+nrCKwFtEY0SRuGIRjj+HGO4ByzB8l7AIHwsmh+HHjDUT+VEN4huTQvF7/wdzfkAP/gPzUELUTEdGh+VTE0Lw+vGJWTB+2zh5Gr3FLBj/mhKqGWpo5oaV/gGNQYq8UD/CuwAAAABJRU5ErkJggg==) top center repeat-x;
  background-color: #1D96D7;
}
:host-context(.wdw) #backgroundGlowContainer {
  width: 100%;
  position: relative;
  margin: auto;
  max-width: 940px;
}
:host-context(.wdw) #backgroundGlow {
  width: 100%;
  height: 800px;
  position: absolute;
  top: -380px;
  z-index: -1;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(71, 218, 255, 0) 70%);
}
:host-context(.wdw) #pageContainer {
  background: transparent;
}
@media all and (max-width: 767px) {
  :host-context(.wdw) #backgroundGlow {
    top: -340px;
    height: 600px;
    background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 218, 255, 0) 70%);
  }
}
@media all and (max-width: 568px) {
  :host-context(.wdw) #backgroundGlow {
    top: -180px;
    height: 300px;
  }
}
:host-context(.wdw) .pepde {
  padding-bottom: 50px;
}
:host-context(.wdw) .top-section {
  display: none;
  width: 95%;
  margin: 0 auto;
  color: #253B56;
}
:host-context(.wdw) .top-section .breadcrumbs-section {
  width: 80%;
  padding-left: 5px;
  padding-bottom: 9px;
}
:host-context(.wdw) .top-section .breadcrumbs-section .breadcrumb-item {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}
:host-context(.wdw) .top-section .breadcrumbs-section .breadcrumb-item span.di.di-home {
  vertical-align: text-top;
  font-size: 14px;
}
:host-context(.wdw) .top-section .breadcrumbs-section .breadcrumb-item span.di.di-next {
  font-size: 10px;
  padding-right: 5px;
  vertical-align: middle;
  color: #73A4BF;
}
:host-context(.wdw) .top-section .breadcrumbs-section .breadcrumb-item a,
:host-context(.wdw) .top-section .breadcrumbs-section .breadcrumb-item a:link {
  font-family: "InspireTWDCMedium";
  font-size: 12px;
  color: #253B56;
}
:host-context(.wdw) .top-section .breadcrumbs-section .breadcrumb-item a:hover {
  color: #1994D7;
  border-bottom: 1px solid #1994D7;
}
:host-context(.wdw) .top-section .print {
  width: 20%;
  text-align: right;
  font-family: "InspireTWDCHeavy";
  font-size: 12px;
  margin-bottom: 9px;
  position: relative;
  padding-right: 20px;
}
:host-context(.wdw) .top-section .print a:link {
  color: #253B56;
}
:host-context(.wdw) .top-section .print a:hover {
  color: #1994D7;
}
:host-context(.wdw) .top-section .print .di-print {
  font-family: PeptasiaInteractive;
  font-size: 14px;
  position: absolute;
  display: block;
  right: 30px;
}
:host-context(.wdw) .top-section .print .es {
  right: 50px;
}
:host-context(.wdw) .top-section .print .fr {
  right: 55px;
}
:host-context(.wdw) .tnc-page {
  width: 95%;
  font-family: "InspireTWDCRoman";
  margin: 0 auto;
  background: #FFF;
  box-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);
  border-radius: 12px;
  padding: 6px 20px 20px;
  color: #424B5A;
  letter-spacing: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
}
:host-context(.wdw) .tnc-page h1 {
  font-size: 20px;
  line-height: 33px;
  font-weight: 400;
  letter-spacing: 0;
  color: #424B5A;
  margin-bottom: 14px;
  letter-spacing: -0.18px;
}
:host-context(.wdw) .tnc-page h3 {
  font-weight: 400;
}
:host-context(.wdw) .tnc-page h3.olci-tnc {
  text-transform: uppercase;
}
:host-context(.wdw) .tnc-page h3.other-tnc {
  margin-bottom: 20px;
  text-decoration: underline;
}
:host-context(.wdw) .tnc-page .page-content p {
  margin-bottom: 20px;
}
:host-context(.wdw) .footer-section {
  width: 95%;
  margin: 0 auto;
  background: #FFF;
  box-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);
  border-radius: 12px;
  padding: 20px 0 20px 0;
  max-width: 940px;
}
:host-context(.wdw) .page-layout {
  background: url('wdw-bg.6dc06ca158c4201a.png') top center repeat-x;
  min-height: 100vh;
  padding: 40px 0 30px;
}
@media (min-width: 767px) {
  :host-context(.wdw) .top-section {
    display: flex;
  }
  :host-context(.wdw) .tnc-page {
    padding: 42px 46px 42px 50px;
  }
  :host-context(.wdw) .tnc-page h1 {
    font-size: 28px;
    line-height: 33px;
    font-weight: 400;
    letter-spacing: 0;
    margin-bottom: 19px;
  }
}
@media (min-width: 1024px) {
  :host-context(.wdw) .tnc-page,
  :host-context(.wdw) .top-section {
    width: 940px;
  }
  :host-context(.wdw) ::ng-deep ul,
  :host-context(.wdw) ::ng-deep ol {
    list-style: disc;
    margin-bottom: 20px;
    padding: 0 0 0 15px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.wdw) ::ng-deep p {
    margin-bottom: 20px;
  }
}
@media (max-width: 1024px) {
  :host-context(.wdw) ::ng-deep ul,
  :host-context(.wdw) ::ng-deep ol {
    list-style: disc;
    padding: 0 19px 0 40px;
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/tnc-page/tnc-page.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/tnc-page/tnc-page.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/app/tnc-page/tnc-page.component.wdw.scss","webpack://./src/assets/style/theme/background.scss"],"names":[],"mappings":"AAAA;ECAA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ECkHA,eAAA;EAgBA,gBAAA;AP5FA;AK/BA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALiCJ;AK/BI;EAEI,sBAAA;ALgCR;AK7BI;EACI,wBAAA;AL+BR;AK3BA;;EAEI,SAAA;EACA,iBAAA;AL6BJ;AK1BA;EACI,WAAA;AL4BJ;AKzBA;EACI,WAAA;AL2BJ;AKxBA;;;;;EAKI,SAAA;AL0BJ;AKvBA;;;;;;;;;;;;EAYI,oBAAA;ALyBJ;AKtBA;EACI,OAAA;ALwBJ;AKtBI;EACI,WAAA;ALwBR;AKrBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALsBR;AKlBA;EACI,WAAA;ALoBJ;AKjBA;EACI,YAAA;ALmBJ;AMnGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANqGJ;AMlGA;;;;;;;;;;;;EAYI,cAAA;ANoGJ;AMjGA;;EAEI,gBAAA;ANmGJ;AMhGA;;EAEI,YAAA;ANkGJ;AMhGI;;;;EAEI,aAAA;ANoGR;AMhGA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANkGJ;AM/FA;EACI,yBAAA;EACA,iBAAA;ANiGJ;AM9FA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANgGJ;AM7FA;;EAEI,sBAAA;AN+FJ;AM5FA;EACI,kBAAA;AN8FJ;AM1FI;EACI,aAAA;AN4FR;AMxFA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AN0FJ;AMrFQ;EACI,gBAAA;EACA,cAAA;ANuFZ;AMnFY;EACI,cAAA;ANqFhB;AOxPA;EACI,aAAA;EACA,UAAA;EACA,cAAA;EACA,cNoBwB;ADsO5B;AOxPI;EACI,UAAA;EACA,iBAAA;EACA,mBAAA;AP0PR;AOxPQ;EACI,qBAAA;EACA,gBAAA;EACA,iBAAA;AP0PZ;AOxPY;EACI,wBAAA;EACA,eAAA;AP0PhB;AOvPY;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;APyPhB;AOtPY;;EAEI,gCC9BU;ED+BV,eAAA;EACA,cNPY;AD+P5B;AOrPY;EACI,cNLI;EMMJ,gCAAA;APuPhB;AOlPI;EACI,UAAA;EACA,iBAAA;EACA,+BC5CiB;ED6CjB,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;APoPR;AOlPQ;EACI,cN3BgB;AD+Q5B;AOjPQ;EACI,cNzBQ;AD4QpB;AOhPQ;EACI,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cNxCgB;AD0R5B;AO/OQ;EACI,cNtCQ;ADuRpB;AO9OQ;EACI,cN1CQ;AD0RpB;AO7OQ;EACI,cNpDgB;ADmS5B;AO1OA;EACI,UAAA;EACA,+BCjFqB;EDkFrB,cAAA;EACA,gBNtFY;EMuFZ,sBAAA;EHpEA,eGsEc;EHrEd,iBGqEoB;EHpEpB,gBAH+C;EAI/C,iBAJqE;AJqTzE;AO5OI;EHxEA,eGyEkB;EHxElB,iBGwEwB;EHvExB,gBAH+C;EAI/C,iBAJqE;EG2EjE,cNpEoB;EMqEpB,mBAAA;EACA,uBAAA;APiPR;AO7OQ;EACI,mBAAA;AP+OZ;AO1OA;EACI,gBN1GY;EM2GZ,iBAAA;EACA,oBAAA;AP4OJ;AOxOA;EACI;IACI,aAAA;EP0ON;EOvOE;IACI,4BAAA;EPyON;EOvOM;IHrGJ,eGsGsB;IHrGtB,iBGqG4B;IHpG5B,gBAH+C;IAI/C,iBAJqE;IGwG7D,mBAAA;EP4OV;AACF;AOvOA;EACI;;IAEI,YAAA;EPyON;EOtOE;IACI,gBAAA;IACA,mBAAA;IACA,mBAAA;IHtHJ,eGwHkB;IHvHlB,iBGuHwB;IHtHxB,gBAH+C;IAI/C,iBAJqE;EJmWvE;EOvOE;IACI,mBAAA;EPyON;AACF;AOtOA;EACI;IACI,gBAAA;IACA,sBAAA;IACA,mBAAA;IHpIJ,eGsIkB;IHrIlB,iBGqIwB;IHpIxB,gBAH+C;IAI/C,iBAJqE;EJiXvE;AACF;;AAnYA;ECJA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EG8IA,eAAA;EAgBA,gBAAA;ATiRA;AKxaA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AL0aJ;AKxaI;EAEI,sBAAA;ALyaR;AKtaI;EACI,wBAAA;ALwaR;AKpaA;;EAEI,SAAA;EACA,iBAAA;ALsaJ;AKnaA;EACI,WAAA;ALqaJ;AKlaA;EACI,WAAA;ALoaJ;AKjaA;;;;;EAKI,SAAA;ALmaJ;AKhaA;;;;;;;;;;;;EAYI,oBAAA;ALkaJ;AK/ZA;EACI,OAAA;ALiaJ;AK/ZI;EACI,WAAA;ALiaR;AK9ZI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AL+ZR;AK3ZA;EACI,WAAA;AL6ZJ;AK1ZA;EACI,YAAA;AL4ZJ;AM5eA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AN8eJ;AM3eA;;;;;;;;;;;;EAYI,cAAA;AN6eJ;AM1eA;;EAEI,gBAAA;AN4eJ;AMzeA;;EAEI,YAAA;AN2eJ;AMzeI;;;;EAEI,aAAA;AN6eR;AMzeA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN2eJ;AMxeA;EACI,yBAAA;EACA,iBAAA;AN0eJ;AMveA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANyeJ;AMteA;;EAEI,sBAAA;ANweJ;AMreA;EACI,kBAAA;ANueJ;AMneI;EACI,aAAA;ANqeR;AMjeA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANmeJ;AM9dQ;EACI,gBAAA;EACA,cAAA;ANgeZ;AM5dY;EACI,cAAA;AN8dhB;AUroBA;EACI,mxCAAA;EACA,yBAAA;AVuoBJ;AUpoBA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AVsoBJ;AUnoBA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EA4CA,qIACI;AV8lBR;AUtlBA;EACI,uBAAA;AVwlBJ;AUrlBA;EACI;IACI,WAAA;IACA,aAAA;IA4CA,sIACI;EVgjBV;AACF;AUxiBA;EACI;IACI,WAAA;IACA,aAAA;EV0iBN;AACF;AS5qBA;EACI,oBAAA;AT8qBJ;AS3qBA;EACI,aAAA;EACA,UAAA;EACA,cAAA;EACA,cRNqB;ADmrBzB;AS3qBI;EACI,UAAA;EACA,iBAAA;EACA,mBAAA;AT6qBR;AS3qBQ;EACI,qBAAA;EACA,gBAAA;EACA,iBAAA;AT6qBZ;AS3qBY;EACI,wBAAA;EACA,eAAA;AT6qBhB;AS1qBY;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,cRnBa;AD+rB7B;ASzqBY;;EAEI,gCDpCU;ECqCV,eAAA;EACA,cRlCS;AD6sBzB;ASxqBY;EACI,cRnCG;EQoCH,gCAAA;AT0qBhB;ASrqBI;EACI,UAAA;EACA,iBAAA;EACA,+BDlDiB;ECmDjB,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;ATuqBR;ASrqBQ;EACI,cRtDa;AD6tBzB;ASpqBQ;EACI,cRvDO;AD6tBnB;ASnqBQ;EACI,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;ATqqBZ;ASlqBQ;EACI,WAAA;AToqBZ;ASjqBQ;EACI,WAAA;ATmqBZ;AS9pBA;EACI,UAAA;EACA,+BDlFqB;ECmFrB,cAAA;EACA,gBRvFY;EQwFZ,2CRvFa;EQwFb,mBAAA;EACA,sBAAA;EACA,cRtFa;EQuFb,iBAAA;ELzEA,eK2Ec;EL1Ed,iBK0EoB;ELzEpB,gBAH+C;EAI/C,iBAJqE;AJ8uBzE;AShqBI;EL7EA,eK8EkB;EL7ElB,iBK6EwB;EL5ExB,gBAH+C;EAI/C,iBAJqE;EKgFjE,cR7FS;EQ8FT,mBAAA;EACA,uBAAA;ATqqBR;ASlqBI;EACI,gBAAA;AToqBR;ASlqBQ;EACI,yBAAA;AToqBZ;ASjqBQ;EACI,mBAAA;EACA,0BAAA;ATmqBZ;AS9pBQ;EACI,mBAAA;ATgqBZ;AS3pBA;EACI,UAAA;EACA,cAAA;EACA,gBR9HY;EQ+HZ,2CR9Ha;EQ+Hb,mBAAA;EACA,sBAAA;EACA,gBAAA;AT6pBJ;AS1pBA;EACI,kEAAA;EACA,iBAAA;EACA,oBAAA;AT4pBJ;ASxpBA;EACI;IACI,aAAA;ET0pBN;ESvpBE;IACI,4BAAA;ETypBN;ESvpBM;ILjIJ,eKkIsB;ILjItB,iBKiI4B;ILhI5B,gBAH+C;IAI/C,iBAJqE;IKoI7D,mBAAA;ET4pBV;AACF;ASvpBA;EACI;;IAEI,YAAA;ETypBN;EStpBE;;IAEI,gBAAA;IACA,mBAAA;IACA,mBAAA;ILnJJ,eKqJkB;ILpJlB,iBKoJwB;ILnJxB,gBAH+C;IAI/C,iBAJqE;EJgzBvE;ESvpBE;IACI,mBAAA;ETypBN;AACF;AStpBA;EACI;;IAEI,gBAAA;IACA,sBAAA;IACA,mBAAA;ILlKJ,eKoKkB;ILnKlB,iBKmKwB;ILlKxB,gBAH+C;IAI/C,iBAJqE;EJ+zBvE;AACF","sourcesContent":[":host-context(.aulani) {\r\n    @import './tnc-page.component.aulani';\r\n}\r\n\r\n:host-context(.wdw) {\r\n    @import './tnc-page.component.wdw';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.top-section {\r\n    display: none;\r\n    width: 95%;\r\n    margin: 0 auto;\r\n    color: $aulani-primary-text-color;\r\n\r\n    .breadcrumbs-section {\r\n        width: 80%;\r\n        padding-left: 5px;\r\n        padding-bottom: 9px;\r\n\r\n        .breadcrumb-item {\r\n            display: inline-block;\r\n            margin-left: 5px;\r\n            margin-right: 5px;\r\n\r\n            span.di.di-home {\r\n                vertical-align: text-top;\r\n                font-size: 14px;\r\n            }\r\n\r\n            span.di.di-next {\r\n                font-size: 10px;\r\n                padding-right: 5px;\r\n                vertical-align: middle;\r\n            }\r\n\r\n            a,\r\n            a:link {\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-size: 12px;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n\r\n            a:hover {\r\n                color: $aulani-hover-link;\r\n                border-bottom: 1px solid $aulani-hover-link;\r\n            }\r\n        }\r\n    }\r\n\r\n    .print {\r\n        width: 20%;\r\n        text-align: right;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        font-size: 12px;\r\n        margin-bottom: 9px;\r\n        position: relative;\r\n        padding-right: 20px;\r\n\r\n        a:link {\r\n            color: $aulani-primary-text-color;\r\n        }\r\n\r\n        a:hover {\r\n            color: $aulani-hover-link;\r\n        }\r\n\r\n        .di-print {\r\n            font-family: PeptasiaInteractive;\r\n            font-size: 14px;\r\n            position: absolute;\r\n            display: block;\r\n            right: 30px;\r\n            color: $aulani-primary-text-color;\r\n        }\r\n\r\n        .di-print:hover {\r\n            color: $aulani-hover-link;\r\n        }\r\n\r\n        .di-print-text:hover {\r\n            color: $aulani-hover-link;\r\n        }\r\n\r\n        .di-print-text {\r\n            color: $aulani-primary-text-color;\r\n        }\r\n    }\r\n}\r\n\r\n.tnc-page {\r\n    width: 95%;\r\n    font-family: $inspiretwdc-roman-font;\r\n    margin: 0 auto;\r\n    background: $primary-color;\r\n    padding: 6px 20px 20px;\r\n\r\n    @include font(14px, 20px);\r\n\r\n    h1 {\r\n        @include font(20px, 33px);\r\n        color: $aulani-primary-text-color;\r\n        margin-bottom: 14px;\r\n        letter-spacing: -0.18px;\r\n    }\r\n\r\n    .page-content {\r\n        p {\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.page-layout {\r\n    background: $primary-color;\r\n    min-height: 100vh;\r\n    padding: 40px 0 20px;\r\n}\r\n\r\n/* For Tablet */\r\n@media (min-width: 767px) {\r\n    .top-section {\r\n        display: flex;\r\n    }\r\n\r\n    .tnc-page {\r\n        padding: 42px 46px 42px 50px;\r\n\r\n        h1 {\r\n            @include font(28px, 33px);\r\n            margin-bottom: 19px;\r\n        }\r\n    }\r\n}\r\n\r\n/* For Desktop */\r\n@media (min-width: 1024px) {\r\n    .tnc-page,\r\n    .top-section {\r\n        width: 940px;\r\n    }\r\n\r\n    ::ng-deep ul {\r\n        list-style: disc;\r\n        margin-bottom: 20px;\r\n        padding: 0 0 0 15px;\r\n\r\n        @include font(14px, 20px);\r\n    }\r\n\r\n    ::ng-deep p {\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    ::ng-deep ul {\r\n        list-style: disc;\r\n        padding: 0 19px 0 40px;\r\n        margin-bottom: 20px;\r\n\r\n        @include font(12px, 16px);\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/theme/background.scss';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.pepde {\r\n    padding-bottom: 50px;\r\n}\r\n\r\n.top-section {\r\n    display: none;\r\n    width: 95%;\r\n    margin: 0 auto;\r\n    color: $wdw-primary-text-color;\r\n\r\n    .breadcrumbs-section {\r\n        width: 80%;\r\n        padding-left: 5px;\r\n        padding-bottom: 9px;\r\n\r\n        .breadcrumb-item {\r\n            display: inline-block;\r\n            margin-left: 5px;\r\n            margin-right: 5px;\r\n\r\n            span.di.di-home {\r\n                vertical-align: text-top;\r\n                font-size: 14px;\r\n            }\r\n\r\n            span.di.di-next {\r\n                font-size: 10px;\r\n                padding-right: 5px;\r\n                vertical-align: middle;\r\n                color: $wdw-breadcrumbs-next-color;\r\n            }\r\n\r\n            a,\r\n            a:link {\r\n                font-family: $inspiretwdc-medium-font;\r\n                font-size: 12px;\r\n                color: $wdw-primary-text-color;\r\n            }\r\n\r\n            a:hover {\r\n                color: $primary-wdw-link;\r\n                border-bottom: 1px solid $primary-wdw-link;\r\n            }\r\n        }\r\n    }\r\n\r\n    .print {\r\n        width: 20%;\r\n        text-align: right;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        font-size: 12px;\r\n        margin-bottom: 9px;\r\n        position: relative;\r\n        padding-right: 20px;\r\n\r\n        a:link {\r\n            color: $wdw-primary-text-color;\r\n        }\r\n\r\n        a:hover {\r\n            color: $primary-wdw-link;\r\n        }\r\n\r\n        .di-print {\r\n            font-family: PeptasiaInteractive;\r\n            font-size: 14px;\r\n            position: absolute;\r\n            display: block;\r\n            right: 30px;\r\n        }\r\n\r\n        .es {\r\n            right: 50px;\r\n        }\r\n\r\n        .fr {\r\n            right: 55px;\r\n        }\r\n    }\r\n}\r\n\r\n.tnc-page {\r\n    width: 95%;\r\n    font-family: $inspiretwdc-roman-font;\r\n    margin: 0 auto;\r\n    background: $primary-color;\r\n    box-shadow: $primary-shadow;\r\n    border-radius: 12px;\r\n    padding: 6px 20px 20px;\r\n    color: $wdw-h3-heading;\r\n    letter-spacing: 0;\r\n\r\n    @include font(14px, 20px);\r\n\r\n    h1 {\r\n        @include font(20px, 33px);\r\n        color: $wdw-h3-heading;\r\n        margin-bottom: 14px;\r\n        letter-spacing: -0.18px;\r\n    }\r\n\r\n    h3 {\r\n        font-weight: 400;\r\n\r\n        &.olci-tnc {\r\n            text-transform: uppercase;\r\n        }\r\n\r\n        &.other-tnc {\r\n            margin-bottom: 20px;\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n\r\n    .page-content {\r\n        p {\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.footer-section {\r\n    width: 95%;\r\n    margin: 0 auto;\r\n    background: $primary-color;\r\n    box-shadow: $primary-shadow;\r\n    border-radius: 12px;\r\n    padding: 20px 0 20px 0;\r\n    max-width: 940px;\r\n}\r\n\r\n.page-layout {\r\n    background: url('../../assets/images/wdw-bg.png') top center repeat-x;\r\n    min-height: 100vh;\r\n    padding: 40px 0 30px;\r\n}\r\n\r\n/* For Tablet */\r\n@media (min-width: 767px) {\r\n    .top-section {\r\n        display: flex;\r\n    }\r\n\r\n    .tnc-page {\r\n        padding: 42px 46px 42px 50px;\r\n\r\n        h1 {\r\n            @include font(28px, 33px);\r\n            margin-bottom: 19px;\r\n        }\r\n    }\r\n}\r\n\r\n/* For Desktop */\r\n@media (min-width: 1024px) {\r\n    .tnc-page,\r\n    .top-section {\r\n        width: 940px;\r\n    }\r\n\r\n    ::ng-deep ul,\r\n    ::ng-deep ol {\r\n        list-style: disc;\r\n        margin-bottom: 20px;\r\n        padding: 0 0 0 15px;\r\n\r\n        @include font(14px, 20px);\r\n    }\r\n\r\n    ::ng-deep p {\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    ::ng-deep ul,\r\n    ::ng-deep ol {\r\n        list-style: disc;\r\n        padding: 0 19px 0 40px;\r\n        margin-bottom: 20px;\r\n\r\n        @include font(12px, 16px);\r\n    }\r\n}\r\n",".pepde {\r\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAKuCAYAAABgwHabAAADZ0lEQVRIS83QZ08UURQG4NzfgaggKggSu9iCsaJYI2qkGLE3BIOKJbFEFBGjRkOv0kHq0kGaAtIEgkgHe++/YHzvYcc7M9ldAfnAlyenz91lxYO/JUYUDfxSUtj/U2J5/T+U6PhILm/o+kBOH7pEFiezF7WMHkSC9J7vEiPSur8h6sZIaifSlC4VybxGJL3AXMJf4ju+SoyI60BDQ/RzNIio9i8cjBAR7agJwto+SyysDTVlhDSkFWvBLegGtyC93ypzrwUNwd1nSO80Y05wu+mTxIhbzSCo6aNMI+aCODcb0AhsBDca0A2sV0E1IqD+g8Su12OOCKDoKRrENY5/HUb869DQQym4Wovulbp/crkWwxou8QPExRpTXKh5LzHi/JN3SpQ1HDj3GCPE2WrM+Q2BBnGmCg2/SkCRIU5Xo3GqCmuEb+VbZXqSp4RvBeYIURORT8UbiflU4ABxogIb3pWIvMt5VC7XvB4hVVCGNS/O8SEwp0euHSvFxuFSpEfK5IjSoyUyh0pe60coIg4a40DxK4npwYH9RRjWsK9YVdtbhA3Cs/ClMqLUswDDGvbkY3h3ARARpR6FnHyseeRjzZ3vuhcgdcsfVIM5N36FcM2jETmilNilw5qrDo2dOqSCHblomGY733XJHZDYtmxEhEsOrmzNQWSULdnYMMTmLKwZYhNvGGJjJk4RGzL69ThnItKDNedMzkMakdP1GUg1OPHaunSZtXzDKQ2nKBKsSUdtGKxO65PYqnROGg6sTMUaRSKlmoYVKdigGkXE8lQVjim9EjMM1hxTjLCMn9KShFNUW5qMyChLknokpiURa4uTVCxKxBWjLORfE12HBBx1SMABwQJ1Oj8eG4aY9wC7RrvUoBGjzOHduXyOoqE0To5mx3VLbJTMiu2SmCHseUMJvmYfS2galMrdmTF4yxhiG4PzhF20AF+ziwa2JpkRhbeMEptIfM001lEYUYIHWUcRoiFqcmQTiWh6JJ6mpJOnhKahSqfyLmF6jrpiWERWEXgaMU2NaIxoRLM2JRyXCUt+nrCKwFtEY0SRuGIRjj+HGO4ByzB8l7AIHwsmh+HHjDUT+VEN4huTQvF7/wdzfkAP/gPzUELUTEdGh+VTE0Lw+vGJWTB+2zh5Gr3FLBj/mhKqGWpo5oaV/gGNQYq8UD/CuwAAAABJRU5ErkJggg==) top center repeat-x;\r\n    background-color: #1D96D7;\r\n}\r\n\r\n#backgroundGlowContainer {\r\n    width: 100%;\r\n    position: relative;\r\n    margin: auto;\r\n    max-width: 940px;\r\n}\r\n\r\n#backgroundGlow {\r\n    width: 100%;\r\n    height: 800px;\r\n    position: absolute;\r\n    top: -380px;\r\n    z-index: -1;\r\n    background:\r\n        -moz-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        -webkit-gradient(\r\n            radial,\r\n            center center,\r\n            0,\r\n            center center,\r\n            100%,\r\n            color-stop(0%, rgba(255, 255, 255, 0.95)),\r\n            color-stop(50%, rgba(255, 255, 255, 0.5)),\r\n            color-stop(70%, rgba(71, 218, 255, 0))\r\n        );\r\n    background:\r\n        -webkit-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        -o-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        -ms-radial-gradient(\r\n            center,\r\n            ellipse cover,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n    background:\r\n        radial-gradient(\r\n            ellipse at center,\r\n            rgba(255, 255, 255, 0.95) 0%,\r\n            rgba(255, 255, 255, 0.5) 50%,\r\n            rgba(71, 218, 255, 0) 70%\r\n        );\r\n}\r\n\r\n#pageContainer {\r\n    background: transparent;\r\n}\r\n\r\n@media all and (max-width: 767px) {\r\n    #backgroundGlow {\r\n        top: -340px;\r\n        height: 600px;\r\n        background:\r\n            -moz-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            -webkit-gradient(\r\n                radial,\r\n                center center,\r\n                0,\r\n                center center,\r\n                100%,\r\n                color-stop(0%, rgba(255, 255, 255, 0.95)),\r\n                color-stop(40%, rgba(255, 255, 255, 0.4)),\r\n                color-stop(70%, rgba(255, 218, 255, 0))\r\n            );\r\n        background:\r\n            -webkit-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            -o-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            -ms-radial-gradient(\r\n                center,\r\n                ellipse cover,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n        background:\r\n            radial-gradient(\r\n                ellipse at center,\r\n                rgba(255, 255, 255, 0.95) 0%,\r\n                rgba(255, 255, 255, 0.4) 40%,\r\n                rgba(255, 218, 255, 0) 70%\r\n            );\r\n    }\r\n}\r\n\r\n@media all and (max-width: 568px) {\r\n    #backgroundGlow {\r\n        top: -180px;\r\n        height: 300px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
